var map = {
	"./Gallery-1-300.webp": 3070,
	"./Gallery-10-300.webp": 3770,
	"./Gallery-2-300.webp": 9279,
	"./Gallery-3-300.webp": 9824,
	"./Gallery-4-300.webp": 5769,
	"./Gallery-5-300.webp": 3018,
	"./Gallery-6-300.webp": 4987,
	"./Gallery-7-300.webp": 604,
	"./Gallery-8-300.webp": 4277,
	"./Gallery-9-300.webp": 3926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;